<template>
    <header class="header-wrapper">
        <div class="container">
            <div class="header-content flex justify-between items-center xl:py-6 md:py-5">

                <Logo />

                <Navbar />

            </div>
        </div>
    </header>
</template>

<script>
    import Logo from "./Logo";
    import Navbar from "./Navbar";
    export default {
        name: "Header",
        components: {
            Navbar,
            Logo
        }
    }
</script>

<style scoped>

</style>